import { BaseBookingModel } from '@xeetr/types/models'

export const AddressColumn = (booking: BaseBookingModel) => {
  const address = booking.customer.info?.address
  if (!address) return ''

  const addressParts = [address.street, address.postalCode, address.city].filter(Boolean)

  if (addressParts.length === 0) return ''

  return <div className="text-muted-foreground text-sm">{addressParts.join(', ')}</div>
}
